import {ITokenService, TokenService} from "../services/token-service";

export module Frag {
    export function init() {
        const frag = angular.module('frag', []);

        frag.service('tokenService', TokenService)
            .factory('authHttpInterceptor', ['$q', '$injector', function ($q: ng.IQService, $injector) {
                /*
                 * Add a jwt token to every request that is made to /api/ or /reportApi/
                 *
                 * TODO - we may want to add a way to disable this on a per-request basis
                 */
                const prefixesToAddAuthTo = [
                    '/api/',
                    '/reportApi/'
                ];

                const tokenURL = '/api/GeoFeature/token';
                let tokenService: ITokenService;

                return {
                    'request': function (request) {
                        if (!request || request.url == tokenURL) return request;
                        if(prefixesToAddAuthTo.some(prefix => request.url.indexOf(prefix) === 0)) {
                            // manually inject the token service...
                            tokenService = tokenService || $injector.get('tokenService');

                            return tokenService.getAuthHeader().then((header) => {
                                if (header) {
                                    request.headers['Authorization'] = header;
                                } else {
                                    delete request.headers['Authorization'];
                                }
                                return request;
                            }, () => {
                                return request;
                            });
                        } else {
                            return $q.resolve(request);
                        }
                    }
                }
            }])
        .config(['$httpProvider', function ($httpProvider : ng.IHttpProvider) {
            // $httpProvider.interceptors.push('authHttpInterceptor');
        }])
    }
}
